import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import chessslogo from '../images/chessslogo.png';

const Support = () => {
  // Check if viewport width is mobile-sized
  const isMobileViewport = window.innerWidth <= 768;

  return (
    <div className="" style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh', 
      width: '100vw', 
      background: '#1a1a1a', 
      padding: isMobileViewport ? '20px' : '20px',
      boxSizing: 'border-box'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: isMobileViewport ? '90%' : '600px', 
        background: '#1a1a1a', 
        padding: isMobileViewport ? '30px 20px' : '40px',
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        textAlign: 'center',
        borderRadius: '10px',
        border: '2px solid #333',
        boxSizing: 'border-box'
      }}>
        <h1 style={{ 
          color: 'white', 
          fontSize: isMobileViewport ? '1.75rem' : '2rem', 
          marginBottom: '30px',
          fontWeight: 'bold'
        }}>
          Support
        </h1>

        <p style={{
          color: 'white',
          fontSize: isMobileViewport ? '1rem' : '1.2rem',
          lineHeight: '1.6',
          marginBottom: '40px',
          maxWidth: '100%',
          wordBreak: 'break-word'
        }}>
          For support, please contact us at{' '}
          <a 
            href="mailto:info@chessthread.com" 
            style={{ 
              color: '#3066BE', 
              textDecoration: 'none',
              fontWeight: 'bold',
              display: isMobileViewport ? 'block' : 'inline',
              marginTop: isMobileViewport ? '10px' : '0'
            }}
            onMouseOver={(e) => e.target.style.color = 'gold'}
            onMouseOut={(e) => e.target.style.color = '#3066BE'}
          >
            info@chessthread.com
          </a>
        </p>

        <Link to="/landing" style={{ textDecoration: 'none' }}>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'transform 0.2s ease'
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <img 
              src={chessslogo} 
              alt="ChessThread Logo" 
              style={{ 
                width: isMobileViewport ? '80px' : '100px', 
                height: isMobileViewport ? '80px' : '100px',
                marginBottom: '10px'
              }} 
            />
            <span style={{ 
              color: 'gold', 
              fontSize: isMobileViewport ? '0.85rem' : '0.9rem',
              fontStyle: 'italic'
            }}>
              Return to ChessThread.com
            </span>
          </div>
        </Link>

        <div style={{
          marginTop: '40px',
          width: '100%',
          borderTop: '1px solid #333',
          paddingTop: '20px'
        }}>
          <p style={{
            color: '#888',
            fontSize: isMobileViewport ? '0.75rem' : '0.85rem',
            marginBottom: '10px'
          }}>
            <strong>Delete Account (Mobile App):</strong>
          </p>
          <p style={{
            color: '#888',
            fontSize: isMobileViewport ? '0.7rem' : '0.8rem',
            lineHeight: '1.4'
          }}>
            More Tab (⋯) → Settings → Delete Account
          </p>
        </div>
      </div>
    </div>
  );
};

export default Support;